import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { renderPasswordField} from './reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from './buttons';
import validate from './validateChangePassword';
import { changeSuperadminPassword } from './changePassword/actions/changePasswordAction';

class changeSuperadminPasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      userID: this.props.loginUserInfo.id,
    };
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      };
    };
  };

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    };
  };

  onSubmitHandler(formData) {
    formData.userID = this.state.userID;
    this.props.changeSuperadminPassword(formData);
    this.handleClose();
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Update Password" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <Dialog className="custom_modal"
        title='Change password'
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    name="currentPassword"
                    type="password"
                    maxLength="20"
                    minLength="6"
                    label="Current Password"
                    component={renderPasswordField}
                  />
                </div>
                <div className="col-sm-12 col-md-6 require">
                  <Field
                    name="newPassword"
                    label="New Password"
                    type="password"
                    maxLength="20"
                    minLength="6"
                    component={renderPasswordField}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-6 require">
                  <Field
                    name="confirmNewPassword"
                    maxLength="20"
                    type="password"
                    minLength="6"
                    label="Confirm New Password"
                    component={renderPasswordField}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
};

function mapStateToProps(state) {
  //console.log('state.login.loginUserInfo....',state.login.loginUserInfo)
  return {
    loginUserInfo: state.login.loginUserInfo,
    fieldError: state.appConfig.fieldError,
  };
};

changeSuperadminPasswordModal = reduxForm({
  form: 'changeSuperadminPasswordModalForm',
  validate,
  enableReinitialize: true,
})(changeSuperadminPasswordModal);

export default connect(mapStateToProps, { changeSuperadminPassword })(changeSuperadminPasswordModal);



// WEBPACK FOOTER //
// ./src/components/changeSuperadminPasswordModal.js